import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './SubscriptionPage.css';
import { logVisit } from '../services/visitorLogService';
import { getAllGames } from '../services/gamesService';

const AISSubscriptionPage = () => {
  const navigate = useNavigate();
  const hasLogged = useRef(false);
  const hasAutoSubmitted = useRef(false);
  const [randomThumbnail] = useState(() => {
    const games = getAllGames();
    const randomGame = games[Math.floor(Math.random() * games.length)];
    return randomGame.thumbnail;
  });
  // Using only one plan now
  
  useEffect(() => {
    // Log the visit when component mounts (prevent double execution).
    // If we arrived from the MSISDN callback, the visit was already logged there
    // WITH the MSISDN (so the backend can map the AIS conversion by MSISDN).
    // Only log here when there is no MSISDN (e.g. direct access) to avoid duplicates.
    if (!hasLogged.current) {
      hasLogged.current = true;
      const msisdn = new URLSearchParams(window.location.search).get('msisdn');
      if (!msisdn) {
        logVisit();
      }
    }

    // Auto-submit subscription
    if (!hasAutoSubmitted.current) {
      hasAutoSubmitted.current = true;
      handleSubscribe();
    }
  }, []);
  
  const handleGoBack = () => {
    navigate(-1);
  };
  
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Function to generate random alphanumeric string
  const generateRefId = (length = 20) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };

  const handleSubscribe = async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      // Generate a random refId (alphanumeric, max 50 chars)
      const refId = generateRefId(20);
      
      // Call the auth-token API with the SAME keyword + shortcode used for the WAP MO.
      // The eTracker AuthToken is signed for a specific keyword/shortcode; if the token
      // is generated for a different (default) keyword, the WAP MO fails with "408
      // Invalid Auth Token". So the token request MUST match the AIS keyword/shortcode.
      const base = process.env.REACT_APP_AUTH_TOKEN_API || 'https://api.gamerclub.mobi/api/dn/th/auth/token';
      const apiUrl = `${base}?keyword=${process.env.REACT_APP_AIS_KEYWORD}&shortcode=${process.env.REACT_APP_AIS_SHORTCODE}`;
      const response = await fetch(apiUrl);
      
      if (!response.ok) {
        throw new Error('Subscription failed. Please try again.');
      }
      
      const data = await response.json();
      
      // The endpoint returns { tokenResponse: "token,price" } on success.
      // Guard against a non-string (error code) response.
      if (typeof data.tokenResponse !== 'string') {
        throw new Error(`Token request failed (${data.tokenResponse}). Please try again.`);
      }
      // Get the token from the response
      const token = data.tokenResponse.split(',')[0];
      
      // Redirect to the payment URL with the token and refId
      const paymentUrl = process.env.REACT_APP_AIS_PAYMENT_URL || 'http://mis.etracker.cc/THwap/WAPMORequest.aspx';
      const telcoId = process.env.REACT_APP_AIS_TELCOID || '3';
      const shortcode = process.env.REACT_APP_AIS_SHORTCODE || '4541392';
      const keyword = process.env.REACT_APP_AIS_KEYWORD || 'YG3';
     // alert(`Redirecting to payment URL: ${paymentUrl}?Telcoid=${telcoId}&Shortcode=${shortcode}&Keyword=${keyword}&refid=${refId}&AuthToken=${token}`);
      
      window.location.href = `${paymentUrl}?Telcoid=${telcoId}&Shortcode=${shortcode}&Keyword=${keyword}&refid=${refId}&AuthToken=${token}`;
    } catch (err) {
      setError(err.message || 'An error occurred during subscription');
      console.error('Subscription error:', err);
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className="subscription-page">
      <div className="subscription-header">
        <button onClick={handleGoBack} className="back-button">
          ← กลับไปที่เกม
        </button>
        <h1>🎮 สมัครสมาชิก</h1>
      </div>
      
      <div className="subscription-content">
        {/* Subscription info box removed */}
        
        <div className="subscription-plans">
          {/* Plan toggle buttons removed */}
          
          <div className="plan-details">
            <h3>Premium Subscription</h3>
            
            <div className="game-image-container">
              <img src={randomThumbnail} alt="Subscription Image" className="subscription-image" />
            </div>
            
            <div className="subscription-details">
              <p>
                บริการ Action Game อัตราค่าบริการ 10 บาทต่อ SMS คุณจะได้รับ 1 SMS ต่อ วัน
              </p>
              <p>
                หรือ สมัครโดยพิมพ์ YG3 ส่งมาที่ 4541392<br/>
                สอบถามโทร : 02-1158814, 9.00 - 18.00 (จันทร์ - ศุกร์)<br/>
                ยกเลิกพิมพ์ STOP YG3 ส่งมาที่ 4541392
              </p>
            </div>
            
            {error && <div className="error-message">{error}</div>}
            <button 
              className={`subscribe-button ${isLoading ? 'loading' : ''}`} 
              onClick={handleSubscribe}
              disabled={isLoading}
              style={{ display: 'none' }}
            >
              {isLoading ? 'กำลังดำเนินการ...' : 'สมัครสมาชิก'}
            </button>
            
            {isLoading && (
              <div className="loading-message">
                <p>กำลังดำเนินการสมัครสมาชิก...</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AISSubscriptionPage;